import { Link } from "react-router-dom";
import { CASE_STUDIES } from "@/data/caseStudies";
import { Reveal } from "@/components/SectionHeader";
import SEO from "@/components/SEO";

export default function CaseStudies() {
  return (
    <div data-testid="case-studies-page">
      <SEO
        title="Case Studies — Anonymized Texas Environmental Investigations"
        description="Field-tested environmental case studies from across Texas. Background, moisture findings, thermal imaging, sampling, lab results, interpretation, recommendations, protocols."
        path="/case-studies"
      />
      <section className="bg-[#0F172A] text-white py-24">
        <div className="container-x">
          <div className="overline text-[#F59E0B] mb-5">Case studies</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.05] max-w-4xl">
            Anonymized field investigations. Documented learning.
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            Every Hurtler engagement becomes a teaching case — anonymized, scientific, and
            structured to advance the profession.
          </p>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.05}>
              <Link to={`/case-studies/${c.slug}`} data-testid={`case-card-${c.slug}`} className="card-soft block p-7 h-full">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#7C3AED]">{c.industry} • {c.location}</div>
                <h3 className="font-display font-bold text-xl text-[#0F172A] mt-3 leading-snug">{c.title}</h3>
                <p className="text-sm text-slate-600 mt-4 leading-relaxed">{c.summary}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
